import React from "react";
import { DiseaseDetail } from "../../../../../domain/disease_knowledge/DiseaseDetail";
import { DiseaseMenuSection, diseaseMenuSectionId } from "./DiseaseMenuSection";
import { ItemContents } from "./ItemContents";

export const DetailContentAssessmentCheckpoint = React.memo(function DetailContentAssessmentCheckpoint(props: Props) {
    const {
        assessmentCheckpointRef,
        disease
    } = props;

    return (
        <>
            <h3 className={"itemName"} id={diseaseMenuSectionId(DiseaseMenuSection.ASSESMENT_CHECKPOINT)} ref={assessmentCheckpointRef}>
                アセスメント作成時のチェックポイント
            </h3>
            <h4 className={"subItemName"}>【心身機能・身体構造（身体機能、運動機能、精神機能に関すること等）】</h4>
            <ItemContents itemContents={disease.assessmentCheckpoint.impairments} />
            <h4 className={"subItemName"}>【活動（起床、買い物、コミュニケーションに関すること等）】</h4>
            <ItemContents itemContents={disease.assessmentCheckpoint.activities} />
            <h4 className={"subItemName"}>【参加（地域での活動や、対人関係に関すること等）】</h4>
            <ItemContents itemContents={disease.assessmentCheckpoint.participations} />
            <h4 className={"subItemName"}>【環境因子（福祉用具の使用状況、家族などの援助者について等）】</h4>
            <ItemContents itemContents={disease.assessmentCheckpoint.environments} />
            <h4 className={"subItemName"}>【個人因子（個人の価値観、趣味、ライフスタイルについて等）】</h4>
            <ItemContents itemContents={disease.assessmentCheckpoint.personals} />
        </>
    );
});

type Props = {
    disease: DiseaseDetail
    assessmentCheckpointRef: React.RefObject<HTMLHeadingElement>
};
